import { logger as N } from "../../shared-lib/index.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.ui.ds] && "boolean" == typeof e[FeatureFlag.ui.Fe])
    return new FeatureFlag(
      e[FeatureFlag.ui.ds],
      e[FeatureFlag.ui.Fe],
      e[FeatureFlag.ui.we],
      e[FeatureFlag.ui.xe],
    );
  N.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.es.ds] && "boolean" == typeof e[FeatureFlag.es.Fe])
    return new FeatureFlag(
      e[FeatureFlag.es.ds],
      e[FeatureFlag.es.Fe],
      e[FeatureFlag.es.we],
      e[FeatureFlag.es.xe],
    );
  N.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}
